/**
 * Recommended minimum emergency fund to keep aside, used consistently across the modules' suggestion engines.
 *
 * Standardised as the GREATER of:
 *   - 6 months of the client's annual living expenses (annual ÷ 2) — the income-replacement rule of thumb; and
 *   - a fixed floor (MIN_EMERGENCY_FUND) — because a retiree's emergencies are lumpy CAPITAL items (a car, a major
 *     home repair, a health event), so a small percentage-of-expenses figure can be dangerously thin.
 *
 * This replaces the previously-scattered flat amounts ($30k/$50k). The client can always choose a different
 * figure; this is the sensible default the funding logic protects, and any reasonable buffer they enter wins.
 */
import type { DraftFactFind } from '../constants/initialFactFind.ts';

export const MIN_EMERGENCY_FUND = 50000;

export function getRecommendedEmergencyFund(factFind: DraftFactFind | undefined): number {
    const annualLiving = factFind?.expenses?.livingExpenses || 0;
    const sixMonths = Math.round(annualLiving / 2);
    return Math.max(MIN_EMERGENCY_FUND, sixMonths);
}
